<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Referral History</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :page="currentPage"/>
          <form-button
            v-if="list.length"
            :click="() => claimCredit()"
            type="primary"
            class="btn-info d-block ml-lg-3 m-l-15"
            :loading="claimLoading"
          >
            Claim Credit
          </form-button>
        </div>
      </div>

    </div>
    <loading-container :loading="loading">
      <div v-if="!list || list.length == 0" class="text-center">
        No referral history found!
      </div>
      <div v-else class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <div class="row">
                  <div class="col-md-12">
                    <div class="dataTables_filter">
                      <label>Total unpaid amount: {{ totalUnpaid | priceDisplay }}</label>
                    </div>
                  </div>
                </div>
                <table class="table table-striped dataTable no-footer">
                  <thead>
                  <tr>
                    <th>#Id</th>
                    <th>Code</th>
                    <th>Amount</th>
                    <th>Date created</th>
                    <th>Status</th>
                  </tr>
                  </thead>
                  <tbody>
                 <tr
                   v-for="(item, index) in list"
                   :class="index % 2 == 0 ? 'odd' : 'even'"
                   :key="index">
                   <td>
                     <span>{{item.id}}</span>
                   </td>
                   <td>
                     <span>{{item.code}}</span>
                   </td>
                   <td>
                     <span>{{item.amount | priceDisplay}}</span>
                   </td>
                   <td>
                     <span>{{item.createdAt | dateDisplay}}</span>
                   </td>
                   <td>
                     <span>{{item.status}}</span>
                   </td>
                 </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
     <div class="row">
       <div class="col-md-12 d-flex justify-content-center">
         <pagination
           :routeName="routeName"
           :current="page"
           :total="total"
         />
       </div>
     </div>
    </loading-container>
  </div>
</template>


<script>
  import { mapGetters, mapActions } from "vuex";

  import LoadingContainer from "@/components/Misc/LoadingContainer";
  import Pagination from "@/components/Misc/Pagination";
  import FormButton from "@/components/Form/FormButton";
  import Breadcrumb from "@/components/Common/Breadcrumb";

  export default {
    name: "ReferralHistory",
    components: {
      LoadingContainer,
      Pagination,
      FormButton,
      Breadcrumb,
    },
    beforeMount() {
      const query = this.$route.query;
      const page = query.page ? parseInt(query.page) : 1;
      this.getListReferral({ page });
    },
    computed: {
      ...mapGetters({
        loading: "referral/loading",
        claimLoading: "referral/claimLoading",
        list: "referral/list",
        count: "referral/count",
        page: "referral/page",
        total: "referral/total",
        totalUnpaid: "referral/totalUnpaid",
      }),
      routeName() {
        return this.$router.name;
      },
      currentPage() {
        return this.$store.state.route.meta.title;
      },
    },
    methods: {
      ...mapActions({
        setField: "referral/setField",
        getListReferral: "referral/getReferralHistory",
        claimCredit: "referral/claimCredit",
      }),
    }
  };
</script>
